export const parishData = {
    address: "ulica Gajowa 39/41, Czestochowa, Polska",
    phone: "34 363 95 97",
    email: "sw.urszulaledochowska@gmail.com",
    accountNumber: "53 1600 1462 1738 4805 0000 0001",
    streets: [
      "Bukowa",
      "Gajowa numery od 31",
      "Grzybowska numery od 10",
      "Jesienna numery od 81",
      "Kamińskiego",
      "Lechonia numery: 30, 32, 34",
      "Lipowa numery od 24 do 52 oraz 11",
      "Marusarza",
      "Olszowa",
      "Orkana",
      "Południowa",
      "Rutkiewicz",
      "Rydza-Śmigłego",
      "Sportowa",
      "Zagórskiego",
      "Zielona",
      "Zimowa"
    ],
    photos: [
      {
        src: "../assets/kosciol.jpg",
        author: "ks. Proboszcz",
        alt: "Kościół pw. Św. Urszuli Ledóchowskiej - wieża"
      },
      {
        src: "../assets/kosciol3.jpg",
        author: "Natanael Brewczyński",
        alt: "Kościół pw. Św. Urszuli Ledóchowskiej - wnętrze"
      },
    ]
  };